import { render, staticRenderFns } from "./approvals_footer.vue?vue&type=template&id=1b4173ec"
import script from "./approvals_footer.vue?vue&type=script&lang=js"
export * from "./approvals_footer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports